var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title glowText"},[_vm._v("Create Room")]),_c('RoomQR')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }